import { requireAccess } from './permission'

export const jobs = [
  {
    path: '/empregos/noticias/:type?/:page?/:id?',
    name: 'JobsArticles',
    component: () => import('views/verticals/jobs/articles/Main'),
    title: 'Artigos',
    icon: 'fa-file-o',
    type: 'vertical',
    menu: true,
    subitems: [
      {
        title: 'Listar',
        type: 'listar',
        submenu: true
      },
      {
        title: 'Cadastrar',
        type: 'cadastrar',
        submenu: true
      },
      {
        title: 'Editar',
        type: 'editar',
        submenu: false
      }
    ],
    adminAccess: true,
    beforeEnter: requireAccess,
    meta: {
      permission: 'admin-jobs'
    }
  },
  // {
  //   path: '/empregos/testes/:type?/:page?/:id?',
  //   name: 'JobsTests',
  //   component: () => import('views/verticals/jobs/tests/Main'),
  //   title: 'Testes',
  //   icon: 'fa-list-ul',
  //   type: 'vertical',
  //   menu: true,
  //   subitems: [
  //     {
  //       title: 'Listar',
  //       type: 'listar',
  //       submenu: true
  //     },
  //     {
  //       title: 'Cadastrar',
  //       type: 'cadastrar',
  //       submenu: true
  //     },
  //     {
  //       title: 'Editar',
  //       type: 'editar',
  //       submenu: false
  //     }
  //   ]
  // },
  {
    path: '/empregos/profissoes/:type?/:page?/:id?',
    name: 'JobsOccupations',
    component: () => import('views/verticals/jobs/professions'),
    title: 'Profissões',
    icon: 'fa-group',
    type: 'vertical',
    menu: true,
    subitems: [
      {
        title: 'Listar',
        type: 'listar',
        submenu: true
      },
      {
        title: 'Cadastrar',
        type: 'cadastrar',
        submenu: true
      },
      {
        title: 'Editar',
        type: 'editar',
        submenu: false
      }
    ],
    editorAccess: true,
    beforeEnter: requireAccess,
    meta: {
      permission: 'admin-jobs'
    }
  },
  // {
  //   path: '/empregos/guia-profissoes/:type?/:page?/:id?',
  //   name: 'JobsOccupationsGuide',
  //   component: () => import('views/verticals/jobs/occupations-guide/Main'),
  //   title: 'Guia de profissÃµes',
  //   icon: 'fa-briefcase',
  //   type: 'vertical',
  //   menu: true,
  //   subitems: [
  //     {
  //       title: 'Listar',
  //       type: 'listar',
  //       submenu: true
  //     },
  //     {
  //       title: 'Cadastrar',
  //       type: 'cadastrar',
  //       submenu: true
  //     },
  //     {
  //       title: 'Editar',
  //       type: 'editar',
  //       submenu: false
  //     }
  //   ]
  // },
  // {
  //   path: '/empregos/cursos/:type?/:page?/:id?',
  //   name: 'JobsCourses',
  //   component: () => import('views/verticals/jobs/courses/Main'),
  //   title: 'Cursos',
  //   icon: 'fa-edit',
  //   type: 'vertical',
  //   menu: true,
  //   subitems: [
  //     {
  //       title: 'Listar',
  //       type: 'listar',
  //       submenu: true
  //     },
  //     {
  //       title: 'Cadastrar',
  //       type: 'cadastrar',
  //       submenu: true
  //     },
  //     {
  //       title: 'Editar',
  //       type: 'editar',
  //       submenu: false
  //     }
  //   ]
  // },
  // {
  //   path: '/empregos/interesses/:type?/:page?/:id?',
  //   name: 'JobsInterests',
  //   component: () => import('views/verticals/jobs/interests/Main'),
  //   title: 'Interesses',
  //   icon: 'fa-book',
  //   type: 'vertical',
  //   menu: true,
  //   subitems: [
  //     {
  //       title: 'Listar',
  //       type: 'listar',
  //       submenu: true
  //     },
  //     {
  //       title: 'Cadastrar',
  //       type: 'cadastrar',
  //       submenu: true
  //     },
  //     {
  //       title: 'Editar',
  //       type: 'editar',
  //       submenu: false
  //     }
  //   ]
  // },
  {
    path: '/empregos/banners/:type?/:page?/:id?',
    name: 'JobsBanners',
    component: () => import('views/verticals/jobs/banners/Main'),
    title: 'Banners',
    icon: 'fa-image',
    type: 'vertical',
    menu: true,
    subitems: [
      {
        title: 'Listar',
        type: 'listar',
        submenu: true
      },
      {
        title: 'Cadastrar',
        type: 'cadastrar',
        submenu: true
      },
      {
        title: 'Editar',
        type: 'editar',
        submenu: false
      }
    ],
    editorAccess: true,
    beforeEnter: requireAccess,
    meta: {
      permission: 'admin-jobs'
    }
  },
  // {
  //   path: '/empregos/temas/:type?/:page?/:id?',
  //   name: 'JobsThemes',
  //   component: () => import('views/verticals/jobs/themes/Main'),
  //   title: 'Temas',
  //   icon: 'fa-tags',
  //   type: 'vertical',
  //   menu: true,
  //   subitems: [
  //     {
  //       title: 'Listar',
  //       type: 'listar',
  //       submenu: true
  //     },
  //     {
  //       title: 'Cadastrar',
  //       type: 'cadastrar',
  //       submenu: true
  //     },
  //     {
  //       title: 'Editar',
  //       type: 'editar',
  //       submenu: false
  //     }
  //   ]
  // },
  // {
  //   path: '/empregos/autores/:type?/:page?/:id?',
  //   name: 'JobsAuthors',
  //   component: () => import('views/verticals/jobs/authors/Main'),
  //   title: 'Autores',
  //   icon: 'fa-pencil',
  //   type: 'vertical',
  //   menu: true,
  //   subitems: [
  //     {
  //       title: 'Listar',
  //       type: 'listar',
  //       submenu: true
  //     },
  //     {
  //       title: 'Cadastrar',
  //       type: 'cadastrar',
  //       submenu: true
  //     },
  //     {
  //       title: 'Editar',
  //       type: 'editar',
  //       submenu: false
  //     }
  //   ]
  // },
  {
    path: '/empregos/faq/:type?',
    name: 'JobsFaq',
    component: () => import('views/verticals/jobs/faq/Main'),
    title: 'Faq',
    icon: 'fa-question-circle',
    type: 'vertical',
    menu: true,
    subitems: [
      {
        title: 'Listar',
        type: 'listar',
        submenu: true
      }
    ],
    editorAccess: true,
    beforeEnter: requireAccess,
    meta: {
      permission: 'admin-jobs'
    }
  },
  {
    path: '/empregos/faq/operadora/:carrierId?',
    name: 'JobsFaqCarrier',
    component: () => import('views/verticals/jobs/faq/Main'),
    menu: false,
    editorAccess: true,
    beforeEnter: requireAccess,
    meta: {
      permission: 'admin-jobs'
    }
  },
  {
    path: '/empregos/faq/operadora/:carrierId?/item/:itemId?',
    name: 'JobsFaqItem',
    component: () => import('views/verticals/jobs/faq/Main'),
    menu: false,
    editorAccess: true,
    beforeEnter: requireAccess,
    meta: {
      permission: 'admin-jobs'
    }
  },
  {
    path: '/empregos/termos/:type?/:page?/:id?',
    name: 'JobsTerms',
    component: () => import('views/verticals/jobs/terms/Main'),
    title: 'Termos',
    icon: 'fa-file-text-o',
    type: 'vertical',
    menu: true,
    subitems: [
      {
        title: 'Listar',
        type: 'listar',
        submenu: true
      },
      {
        title: 'Cadastrar',
        type: 'cadastrar',
        submenu: false
      },
      {
        title: 'Editar',
        type: 'editar',
        submenu: false
      }
    ],
    editorAccess: true,
    beforeEnter: requireAccess,
    meta: {
      permission: 'admin-jobs'
    }
  },
  // {
  //   path: '/empregos/versions/:type?/:page?/:id?',
  //   name: 'Versions',
  //   component: () => import('views/verticals/jobs/versions'),
  //   title: 'Versão dos aplicativos',
  //   icon: 'fa-tablet',
  //   type: 'vertical',
  //   menu: true,
  //   subitems: [
  //     {
  //       title: 'Listar',
  //       type: 'listar',
  //       submenu: true
  //     },
  //     // {
  //     //   title: 'Cadastrar',
  //     //   type: 'cadastrar',
  //     //   submenu: true
  //     // },
  //     {
  //       title: 'Editar',
  //       type: 'editar',
  //       submenu: false
  //     }
  //   ],
  //   editorAccess: true,
  //   beforeEnter: requireAccess,
  //   meta: {
  //     permission: 'admin-jobs'
  //   }
  // },
  {
    path: '/empregos',
    component: () => import('views/verticals/jobs/articles/Main')
  }
]



// WEBPACK FOOTER //
// ./src/router/jobs.js